// 0.00045 MB / 0.45KB DocSol Limit
const MIN_FILE_SIZE = (0.45 / 1024);
// 10MB limit for each individual document upload
const MAX_FILE_SIZE = 10;
// 50MB limit for all documents uploaded
const MAX_TOTAL_FILE_SIZE = 50;
const MAX_FILE_NAME_LENGTH = 100;
// 200 file limit across all dropzones
const MAX_FILE_COUNT = 200;

const ACCEPTED_FILES = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'text/rtf': ['.rtf'],
  'application/rtf': ['.rtf'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
};

const ACCEPTED_IMAGES = {
  'image/png':['.png'],
  'image/bmp':['.bmp'],
  'image/jpeg':['.jpg','.jpeg'],
  'image/tiff':['.tiff','.tif'],
  'application/pdf': ['.pdf']
};

const STEP_NAMES = {
  STEP_ONE: { label: 'Details', value:'details' },
  STEP_TWO: { label:'Contractor info' , value:'contractorInfo' },
  // STEP_THREE: { label:'Supplement type' , value:'supplementType' },
  STEP_FOUR: { label:'Estimate/ Invoice',  value:'estimateFiles' },
  STEP_FIVE: { label:'Supporting files' , value:'supportingFiles' },
  STEP_SIX: { label:'Review',  value:'review' }
};

const HEADINGS = {
  DETAILS: {
    CLAIM: 'Tell us about your supplement',
    CONTACT: 'What are your contact details?',
    TAX_ID_CONTRACTOR: 'What is your business Federal Tax ID?',
    TAX_ID_NON_CONTRACTOR: "What is your contractor's Federal Tax ID?",
    GOOGLE_CONTRACTOR: "Let's help you find your business address",
    GOOGLE_NON_CONTRACTOR: "Let's help you find your contractor's address",
    ADDRESS: 'Have we got these details correct?'
  },
  CONTRACTOR:{
    CONTRACTOR_OR_NOT:'Are you using a contractor for the repairs?',
    TAXID:"What is your Contractor's Federal Tax ID?",
    FIND_ADDRESS:"Let's help you find your contactor's address",
    CORRECT_DETAILS:'Have we got these details correct?'
  },
  SUPPLEMENT: {
    SUPPLEMENT_DETAILS: 'Tell us your supplement details',
    CHECK_ALL:'Check All that apply to your supplement'
  },
  UPLOAD_INVOICE: 'Upload the original estimate or invoice?',
  UPLOAD_SUPPORTING_FILES: 'Upload Supporting files for your supplement',
  REVIEW: 'Please review all details below'
};

const NOTIFICATIONS = {
  ESTIMATE_TOTAL_VALUE: 'Please provide below the total estimate amount (including original estimate, previous supplements,' +
    ' and this supplement).',
  SUPPLEMENT_VALUE: 'Please provide below the supplement amount for this submission (not including original estimate' +
    ' and not including previous supplements).',
  GOOGLE_CONTRACTOR: 'Start typing your business name or address below',
  GOOGLE_NON_CONTRACTOR: 'Start typing your contractor\'s business name or address below',
  UPLOAD_TITLE: 'Important',
  UPLOAD_INFO: 'Please upload your Supplement Estimate and any other supporting documentation into the fields above',
  UPLOAD_BULLET_A: 'Each document should be less than 10MB in size',
  UPLOAD_BULLET_B: 'Total upload size for all documents should not exceed 50 MB',
  REVIEW_SUBMIT: 'Press Submit to send all information to your Adjuster'
};

const DETAILS = {
  claimNumber: {
    label: '9-digit claim number',
    placeholder: 'XXXXXXXXX',
    type: 'text',
    mask: undefined,
    filter: /^\d{1,9}$/
  },
  // uiTotalAmount: {
  //   label: 'Total estimate amount',
  //   placeholder: '0.00',
  //   type: 'text',
  //   mask: undefined,
  //   filter: /^(\d|[1-9]\d{1,5})(\.\d{0,2})?$/
  // },
  uiSupplementAmount: {
    label: 'Supplement amount',
    placeholder: '0.00',
    type: 'text',
    mask: undefined,
    filter: /^(\d|[1-9]\d{1,5})(\.\d{0,2})?$/
  },
  // repairsComplete: {
  //   label: 'Have your repairs been completed?',
  //   options: [
  //     { label: 'Yes', value: 'Yes' },
  //     { label: 'No', value: 'No' }
  //   ]
  // },
  linesOfCoverage: {
    label: 'Select all lines of coverage that apply.',
    reviewLabel: 'Lines of coverage',
    options: [
      'Dwelling',
      'Other Structure',
      'Personal Property',
      'Additional Living Expenses'
    ]
  },
  usingContractor: {
    label: 'Who is completing the repairs?',
    options: [
      { label: 'I am using a contractor', value: 'true' },
      { label: 'I am not using a contractor', value: 'false' }
    ]
  },
  contactName: {
    label: 'First and last name',
    placeholder: '',
    type: undefined,
    mask: undefined,
    filter: /^[a-z ,.'-]{1,200}$/i
  },
  contactEmail: {
    label: 'Email',
    placeholder: '',
    type: 'email',
    mask: undefined,
    filter: /^.{1,200}$/
  },
  contactPhoneNumber: {
    label: 'Phone number',
    placeholder: '',
    type: 'tel',
    mask: 'phone',
    filter: undefined
  },
  // contractorTaxId: {
  //   label: 'IRS Tax ID (optional)',
  //   placeholder: 'XX-XXXXXXX',
  //   type: 'text',
  //   mask: undefined,
  //   filter: /^\d{0,2}$|^(\d{2}-\d{0,7})$/
  // },
  contractorName: {
    label: 'Business name',
    placeholder: '',
    type: undefined,
    mask: undefined,
    filter: /^.{1,200}$/
  },
  contractorAddress: {
    label: 'Address',
    placeholder: '',
    type: undefined,
    mask: undefined,
    filter: /^.{1,200}$/
  },
  contractorCity: {
    label: 'City',
    placeholder: '',
    type: undefined,
    mask: undefined,
    filter: /^.{1,200}$/
  },
  contractorState: {
    label: 'State',
    placeholder: '',
    type: undefined,
    mask: undefined,
    filter: undefined
  },
  contractorZipCode: {
    label: 'ZIP Code',
    placeholder: '',
    type: undefined,
    mask: 'zipCode',
    filter: /^\d{0,5}$/
  },
  contractorEmail: {
    label: 'Email address',
    placeholder: '',
    type: 'email',
    mask: undefined,
    filter: /^.{1,200}$/
  },
  contractorPhoneNumber: {
    label: 'Phone number',
    placeholder: '',
    type: 'tel',
    mask: 'phone',
    filter: undefined
  }
};

const REASON = {
  FREETEXT_PLACEHOLDER: 'Add a description of your supplement request here...',
  CATEGORIES_TEXT: 'Please select all categories that apply.',
  TAG_OPTIONS: [
    'Scope Change',
    'Pricing Differences',
    'Additional Damage',
    'Overhead & Profit',
    'Other'
  ],
  OTHER_CATEGORY: {
    CATEGORY: 'Other',
    TEXT: 'Please specify the other category.',
    LABEL: 'Other Category',
    PLACEHOLDER: '',
    FILTER: /^.{1,200}$/
  }
};

const UPLOADS = {
  ESTIMATE: {
    CATEGORY: 'estimate',
    HEADING: 'Upload the original estimate or invoice',
    SUB_HEADING: 'You must upload 1 file containing your primary supplement estimate or invoice document. On' +
     ' the next screen, you can upload any supporting documents for the changes needed.',
    TEXT: {     
      TEXT_START: 'File requirements:',
      LIST_ITEM_A: 'We accept most common file types like .pdf, .doc, .xls',
      LIST_ITEM_B:'Each individual file must be under 10 MB'
      },      
    FILE_LABEL: 'Estimate'
  },
  PHOTOS: {
    CATEGORY: 'photos',
    HEADING: 'Upload supporting files for your supplement (optional)',
    SUB_HEADING: "You don't have to, but you can include any supporting files that show what has changed in the" + 
    ' original estimate, such as invoices or contracts.',
    TEXT: {     
      TEXT_START: 'File requirements:',
      LIST_ITEM_A: 'We accept most common file types like .pdf, .doc, .xls',
      LIST_ITEM_B:'Combined size of all files must be under 100 MB',
      LIST_ITEM_C:'Each individual file must be under 10 MB'
      },   
    FILE_LABEL: 'Photo'
  },
  OTHER: {
    CATEGORY: 'other',
    HEADING: 'All other documents',
    DROPZONE: 'Drag \'n\' drop or click to select all other documents relating to your supplement',
    POPOVER: {
      TEXT_START: 'Now, tell us about your files ',
      LIST_ITEM_A: 'After you upload your files, please specify if the file is a photo or a document. ',
      LIST_ITEM_B: 'Photos capture any existing damage or repairs made as described in estimate/invoice. ',
      LIST_ITEM_C: 'Documents may include contracts, related invoices, code support notes, or even photo reports. ',
      LIST_ITEM_D: 'Telling us this makes sure your files get sorted out and handled the right way.'
    },
    FILE_LABEL: 'Other'
  }
};

const REVIEW = {
  HEADING: 'Please review all details below',
  COMPANY_HEADING: 'Supplement details',
  SUPPLEMENT_HEADING: 'Supplement type',
  DOCUMENTS_HEADING: 'Supporting files',
  ESTIMATE_HEADING: 'Estimate/Invoice',

  CONTRACTOR_COMPANY_DETAILS_HEADING: 'Business details',
  NON_CONTRACTOR_COMPANY_DETAILS_HEADING: 'Contractor details'
};

const PERSONA_MODAL = {
  // HEADER: 'Welcome',
  HEADER: 'Welcome to the supplement portal',
  // RADIO_GROUP_TEXT: 'To begin your request, please tell us which of the following best describes you',
  RADIO_GROUP_TEXT: 'Before continuing, please tell us about yourself.',
  RADIO_GROUP_SR_TEXT: 'Choose one from the following options which best describes you',
  PERSONA_OPTIONS: [
    'Policyholder',
    'I am a Contractor',
    'Other'
  ]
};

const SUBMIT_MODAL = {
  HEADERS: {
    SUBMITTING: 'Please wait',
    SUCCESS: 'Thank you!',
    ERROR: 'Error'
  },
  TEXT: {
    SUBMITTING: 'Your supplement is being uploaded',
    SUCCESS: 'Once the supplement has been reviewed a member of staff will contact you to discuss supplement details',
    ERROR: 'Sorry! An unexpected error has occurred, please contact the Adjuster listed on the estimate'
  }
};

const ERROR_LIST = {
  claimNumber: 'Please provide a valid 9 digit claim number.',
  // uiTotalAmount: 'The total estimate amount field cannot be left blank.',
  uiSupplementAmount: 'The Supplement amount field cannot be left blank.',
  linesOfCoverage: 'Please select one or more lines of coverage',
  contactName:'Please provide a name so we can contact you in the event of any queries.',
  contactEmail: 'Please provide a valid email address.',
  contactPhoneNumber: 'Please provide a valid telephone number.',
  // contractorTaxId: 'Please provide a valid Federal Tax ID in the format of XX-XXXXXXX or leave the field empty.',
  contractorName: 'Please provide a company name.',
  contractorAddress: 'Please provide an address.',
  contractorCity: 'Please provide a city.',
  contractorState: 'Please select a valid state.',
  contractorZipCode: 'Please provide a valid zip code.',
  contractorEmail: 'Please provide a valid company email address',
  contractorPhoneNumber: 'Please provide a valid company telephone number.',
  freeText: 'Please provide a description of the changes needed in your supplement.',
  otherCategory: 'Please specify the other category.',
  noSupplement: 'You must upload ONE supplement estimate or invoice.',
  invalidSupplement: 'Please remove the invalid supplement estimate file.',
  invalidPhotos: 'Please remove the invalid photo file(s).',
  invalidOtherDocuments: 'Please remove the invalid other document file(s).'
};

const isMandatory = (val) => val !== null && val !== undefined && val.length > 0;

const STATE_LIST = [
  { code: 'AL', contractorState: 'Alabama' },
  { code: 'AK', contractorState: 'Alaska' },
  { code: 'AZ', contractorState: 'Arizona' },
  { code: 'AR', contractorState: 'Arkansas' },
  { code: 'CA', contractorState: 'California' },
  { code: 'CO', contractorState: 'Colorado' },
  { code: 'CT', contractorState: 'Connecticut' },
  { code: 'DE', contractorState: 'Delaware' },
  { code: 'DC', contractorState: 'District of Columbia' },
  { code: 'FL', contractorState: 'Florida' },
  { code: 'GA', contractorState: 'Georgia' },
  { code: 'HI', contractorState: 'Hawaii' },
  { code: 'ID', contractorState: 'Idaho' },
  { code: 'IL', contractorState: 'Illinois' },
  { code: 'IN', contractorState: 'Indiana' },
  { code: 'IA', contractorState: 'Iowa' },
  { code: 'KS', contractorState: 'Kansas' },
  { code: 'KY', contractorState: 'Kentucky' },
  { code: 'LA', contractorState: 'Louisiana' },
  { code: 'ME', contractorState: 'Maine' },
  { code: 'MD', contractorState: 'Maryland' },
  { code: 'MA', contractorState: 'Massachusetts' },
  { code: 'MI', contractorState: 'Michigan' },
  { code: 'MN', contractorState: 'Minnesota' },
  { code: 'MS', contractorState: 'Mississippi' },
  { code: 'MO', contractorState: 'Missouri' },
  { code: 'MT', contractorState: 'Montana' },
  { code: 'NE', contractorState: 'Nebraska' },
  { code: 'NV', contractorState: 'Nevada' },
  { code: 'NH', contractorState: 'New Hampshire' },
  { code: 'NJ', contractorState: 'New Jersey' },
  { code: 'NM', contractorState: 'New Mexico' },
  { code: 'NY', contractorState: 'New York' },
  { code: 'NC', contractorState: 'North Carolina' },
  { code: 'ND', contractorState: 'North Dakota' },
  { code: 'OH', contractorState: 'Ohio' },
  { code: 'OK', contractorState: 'Oklahoma' },
  { code: 'OR', contractorState: 'Oregon' },
  { code: 'PA', contractorState: 'Pennsylvania' },
  { code: 'RI', contractorState: 'Rhode Island' },
  { code: 'SC', contractorState: 'South Carolina' },
  { code: 'SD', contractorState: 'South Dakota' },
  { code: 'TN', contractorState: 'Tennessee' },
  { code: 'TX', contractorState: 'Texas' },
  { code: 'UT', contractorState: 'Utah' },
  { code: 'VT', contractorState: 'Vermont' },
  { code: 'VA', contractorState: 'Virginia' },
  { code: 'WA', contractorState: 'Washington' },
  { code: 'WV', contractorState: 'West Virginia' },
  { code: 'WI', contractorState: 'Wisconsin' },
  { code: 'WY', contractorState: 'Wyoming' }
];

const LIBERTY_FOOTER = {
  baseUrl: 'https://www.libertymutualgroup.com/about-lm/',
  links: {
    privacy: 'our-company/privacy-policy',
    security: 'our-company/security-policy',
    accessibility: 'corporate-information/web-accessibility-policy',
    terms: 'our-company/terms-and-conditions',
    fraud: 'our-company/fraud-protection-tips',
    equal:
      'corporate-information/equal-employment-opportunity-and-anti-discrimination-policy',
    cybertrust:
      'https://smp-01.verizonbusiness.com/certinfo/certified.do?CERTID=072505G7001',
    bbb: 'https://www.bbb.org/boston/business-reviews/insurance-services/liberty-mutual-group-in-boston-ma-89/#bbbonlineclick',
    verisign:
      'https://sealinfo.websecurity.norton.com/splash?form_file=fdf/splash.fdf&type=GOLD&sealid=1&dn=www.libertymutual.com&lang=en'
  }
};

const GOOGLE_LIBRARIES = ['places'];

const limitStringToUTF8MB3 = (string) => {
  // Surrogate characters are reserved for constructing characters outside the Basic Multilingual Plane.
  const unicodeSurrogates = /[\uD800-\uDFFF]/g;
  // The output is a string of characters within the BMP / 3 Bytes of UTF-8.
  return string.replace(unicodeSurrogates, '');
};

const TRACK_EVENTS = {
  STEP_CHANGE : 'stepChange',
  LINE_OF_COVERAGE: 'lineOfCoverage',
  SUPPLEMENT_CATEGORY: 'supplementCatagory',
  PERSONA_SELECTED: 'personaSelected',
  SUBMIT: 'submitComplete',
  SUBMIT_ERROR: 'submitError'
};

export {
  ACCEPTED_FILES,
  ACCEPTED_IMAGES,
  STEP_NAMES,
  HEADINGS,
  NOTIFICATIONS,
  DETAILS,
  REASON,
  UPLOADS,
  REVIEW,
  ERROR_LIST,
  STATE_LIST,
  LIBERTY_FOOTER,
  GOOGLE_LIBRARIES,
  PERSONA_MODAL,
  SUBMIT_MODAL,
  MAX_FILE_SIZE,
  MAX_TOTAL_FILE_SIZE,
  MAX_FILE_NAME_LENGTH,
  MAX_FILE_COUNT,
  MIN_FILE_SIZE,
  isMandatory,
  limitStringToUTF8MB3,
  TRACK_EVENTS
};
